let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("sXDfU")).then(() => parcelRequire('9PwX5'));